import * as React from 'react'

const style = require('./Select.css')

interface Option {
  value: string;
  text: string;
}

interface Props {
  options: Array<Option>;
  onChange: (value: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  className?: string;
  label?: string;
  id?: string;
}

export const Select = ({ options, onChange, value, className, label, id='' }: Props) => (
  <div className={style.container}>
    {label && <label htmlFor={id}>{label}</label>}
    <svg className={style.chevron} viewBox="0 0 7 12">
      {/* eslint-disable-next-line max-len */}
      <path d="M.27 10.46a.89.89 0 0 0 0 1.28c.36.35.94.35 1.3 0l5.16-5.1a.89.89 0 0 0 0-1.28L1.57.26a.93.93 0 0 0-1.3 0 .89.89 0 0 0 0 1.28L4.5 6 .27 10.46z" fill="#A9B0B7" fillRule="evenodd" />
    </svg>
    <select onChange={onChange} value={value} className={`${style.select} ${className || ''}`} id={id}>
      {options.map(option => (
        <option key={option.value} value={option.value}>{option.text}</option>
      ))}
    </select>
  </div>
)
